/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';
// custom component import
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { coverageGapHead } from './gridComponents/CoverageGapHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import DatePickerRender from './gridComponents/DatePickerRender';
import {
  dispatchCoverageTable,
  handleErrorMessages,
  maintainContractActions,
  dispatchDeleteCoverageGap,
  addCoverageDate,
} from '../store/actions';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';

const CoverageGap = (props) => {
  const { fullScreenView, setFullScreenView, isEnablebyRole = true } = props;
  const dispatch = useDispatch();
  const maintainContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.maintainContractState
  );
  const getCoverageTable = useSelector(
    (state) => state.sharedState.ContractReducer.getCoverageTable
  );
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  const add_coverage_date = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.add_coverage_date;
  });
  const gridRef = React.useRef();
  const [gridApi, setGridApi] = React.useState(null);
  const [selectedRow, setSelectedRow] = React.useState();
  const [deletePopup, setDeletePopup] = React.useState(false);
  const [cellInfo, setCellInfo] = React.useState('');
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const onSelectionChanged = useCallback(
    (val) => {
      const selectedRows = val.api.getSelectedRows();
    },
    [gridApi]
  );

  // click on delete option
  const deleteSelectRowData = () => {
    let localErr = errorMessagesFromRedux || [];
    dispatch(dispatchCoverageTable({}, cellInfo.rowIndex, '', 'Delete'));
    setCellInfo('');
    setDeletePopup(false);
    if (cellInfo.data.alreadyAdded == true) {
      dispatch(dispatchDeleteCoverageGap(cellInfo.data));
    }
    localErr = localErr?.filter(
      (item) => !item.message?.includes(`Row ${cellInfo.rowIndex + 1}`)
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
      })
    );
  };
  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };
  const handleAddNewRowOnGrid = () => {
    const tempObj = {
      startDate: null,
      endDate: null,
      time: new Date().getTime(),
      alreadyAdded: false,
      indexKey: '',
    };
    dispatch(dispatchCoverageTable(tempObj, '', '', 'Add'));
    handleClearFilter();
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
      })
    );
  };
  React.useEffect(() => {
    if (add_coverage_date) {
      dispatch(addCoverageDate(false));
      handleAddNewRowOnGrid();
    }
  }, [add_coverage_date]);
  // ag-grid frame work components
  const frameworkComponents = {
    ActionCellRender: (cellInfo) => {
      return (
        <div className="tdCell icon-btn-group" data-testid="action-column">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="float-left"
              data-testid="add-new-log-check"
              aria-label="Add new log check"
              variant="text"
              disabled={isEnablebyRole === false}
              onClick={() => {
                handleAddNewRowOnGrid();
              }}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Delete</Tooltip>}
          >
            <Button
              className="float-left"
              data-testid="delete-new-log-check"
              aria-label="Delete"
              variant="text"
              disabled={isEnablebyRole === false}
              onClick={() => {
                setCellInfo(cellInfo);
                setDeletePopup(true);
              }}
            >
              <SVGComponent iconName="Icon-delete" />{' '}
            </Button>
          </OverlayTrigger>
        </div>
      );
    },
    StartDate: (props) => <DatePickerRender {...props} isEnablebyRole={isEnablebyRole} />,
    EndDate: (props) => <DatePickerRender {...props} isEnablebyRole={isEnablebyRole} />,
  };
  return (
    <div>
      <div
        className="frr-requestmailing-labels panel-body FRR-custom-table tbl-manufacturer-inner"
        data-testid="Coverage-gap-component"
      >
        <TableGrid
          ref={gridRef}
          gridHeight={fullScreenView ? '70vh' : 400}
          data-testid="contract-search-table"
          rowData={getCoverageTable}
          columnDefs={coverageGapHead}
          rowSelection="multiple"
          setSelectedRow={setSelectedRow}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          addButtonText="Add Date"
          disableAdd={ isEnablebyRole === false}
          disableAddButton={isEnablebyRole === false}
          handleAddNewRow={() => { 
            handleAddNewRowOnGrid();
          }}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          onSelectionChanged={onSelectionChanged}
          applyFilter={false}
          fileName="Mantain Contract - Coverage Gap"
          frameworkComponents={frameworkComponents}
          exportFile
        />
      </div>
      <SaveCancelPopup
        open={deletePopup}
        data-testid="deletePopup"
        title="Delete"
        moduleName="the selected record"
        onConfim={() => {
          deleteSelectRowData();
        }}
        onCancel={() => {
          setDeletePopup(false);
        }}
      />
    </div>
  );
};
export default CoverageGap;
